// extracted by mini-css-extract-plugin
export default {"table":"LastTimestamp_table__1YDp6","timestamp":"LastTimestamp_timestamp__ETZaG","depth":"LastTimestamp_depth__FUciC"};